import { render, staticRenderFns } from "./comboFund.vue?vue&type=template&id=185791e2"
import script from "./comboFund.vue?vue&type=script&lang=js"
export * from "./comboFund.vue?vue&type=script&lang=js"
import style0 from "./comboFund.vue?vue&type=style&index=0&id=185791e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports